import CryptoJS from "crypto-js";

const menuService = {
  menuData: [],
  userPermissions: [],
  mapMenuDataFromSource(inputData) {
    var outputMenu = this.getMenuLevel(0, inputData);
    return outputMenu;
  },
  getMenuLevel(level, inputData) {
    var menuData = this.sortedArray(level, inputData);

    var hasData = menuData && menuData.length;
    var outputMenu = [];

    if (hasData) {
      menuData.forEach((item) => {
        var routes = {};
        var hasroute = !!item.ClaimsRouteName;

        if (hasroute) {
          var normalizedRoute = item.ClaimsRouteName.startsWith("/")
            ? item.ClaimsRouteName
            : "/" + item.ClaimsRouteName;
          routes = {
            route: normalizedRoute
          };
        }

        var childrenMenu = this.getMenuLevel(item.ClaimsId, inputData);
        var thisNodeID = item.ClaimsParentId + "-" + item.ClaimsId;
        var exists = outputMenu.find((x) => x.menuItem.nodeId == thisNodeID);

        var menu = {};
        if (!exists) {
          menu = {
            menuItem: {
              nodeId: item.ClaimsParentId + "-" + item.ClaimsId,
              nodeText: item.ClaimsName,
              iconCss: item.ClaimsIconClass,
              routes: routes,
              childItems: childrenMenu
            },
            menuPermissions: item.access
          };
          outputMenu.push(menu);
        } else {
          menu = exists;
          var hasChildren = childrenMenu && childrenMenu.length;
          if (hasChildren) {
            childrenMenu.forEach((child) => {
              try {
                var cExists = undefined;

                if (
                  menu.menuItem.childItems &&
                  menu.menuItem.childItems.length
                ) {
                  cExists = menu.menuItem.childItems.find(
                    (i) => i.menuItem.nodeId == child.menuItem.nodeId
                  );
                }

                if (!cExists) {
                  menu.childItems.push(child);
                }
              } catch (error) {
                console.log(error);
              }
            });
          }
        }
      });
      return outputMenu;
    } else {
      return null;
    }
  },
  encryptMenu(payload, token) {
    var encrypted = CryptoJS.AES.encrypt(payload, token);
    //U2FsdGVkX18ZUVvShFSES21qHsQEqZXMxQ9zgHy+bu0=
    return encrypted.toString();
    //var decrypted = CryptoJS.AES.decrypt(encrypted, "Secret Passphrase");
    //4d657373616765
  },
  decryptMenu(payload, token) {
    var decrypted = CryptoJS.AES.decrypt(payload, token);
    return decrypted.toString(CryptoJS.enc.Utf8);
  },
  getHomeItem() {
    return {
      nodeId: "00",
      nodeText: "Inicio",
      iconCss: "icon-home icon",
      routes: {
        route: "AppSolicitudes",
        routeParams: "{ mock: 1} "
      }
    };
  },
  getLogoutItem() {
    return {
      nodeId: "-99",
      nodeText: "Cerrar Sesión",
      iconCss: "icon-key icon",
      routes: {
        route: "logout"
      }
    };
  },
  mapPapirusMenuFromObject(menuInput) {
    /*
        Ejemplo de cómo mapear a la salida esperada por Syncfusion
        var children = [];
        if (childrenMenu && childrenMenu.length > 0) {
          children = childrenMenu.map(x => {
            return x.menuItem;
          });
        }
      */
    var menuItems = menuInput.map((item) => {
      return item.menuItem;
    });

    var hasItems = menuItems && menuItems.length;
    if (hasItems) {
      menuItems.forEach((x) => {
        var hasChildItems = x.childItems && x.childItems.length;
        if (hasChildItems) {
          x.nodeChild = x.childItems.map((item) => {
            delete item.menuItem.childItems;
            return item.menuItem;
          });
        }
        delete x.childItems;
      });
    }

    return menuItems;
  },
  mapRoutePermissionsFromObject(menuData) {
    var instance = this;
    var routes = [];
    var hasData = menuData && menuData.length;
    if (hasData) {
      menuData.forEach((item) => {
        var route = instance.getPermissionObjectFromMenuItem(item);
        if (route != null) routes.push(route);
        var hasChildren =
          item.menuItem.childItems && item.menuItem.childItems.length;
        if (hasChildren) {
          item.menuItem.childItems.forEach((child) => {
            var childRoute = instance.getPermissionObjectFromMenuItem(child);
            if (childRoute != null) routes.push(childRoute);
          });
        }
      });
    }
    return routes;
  },
  getPermissionObjectFromMenuItem(item) {
    try {
      var ret = {};
      ret.menu = item.menuItem.nodeText ?? "";
      ret.route = item.menuItem.routes.route ?? "";
      ret.menuPermissions = item.menuPermissions;
      return ret;
    } catch (error) {
      return null;
    }
  },
  getMenuAccessFromString(profile, tkn) {
    var tknData = tkn.split(".");
    var pass = tknData[2];
    var menu = this.decryptMenu(profile, pass);

    try {
      var objMenu = JSON.parse(menu) ?? {};
      var routes = this.mapRoutePermissionsFromObject(objMenu.menuItems);
      return routes;
    } catch (error) {
      console.log(error);
    }
  },
  getMenuObjectFromString(profile, tkn) {
    var tknData = tkn.split(".");
    var pass = tknData[2];
    var menu = this.decryptMenu(profile, pass);

    try {
      var objMenu = JSON.parse(menu) ?? {};

      var mappedMenu = this.mapPapirusMenuFromObject(objMenu.menuItems);

      mappedMenu.unshift(this.getHomeItem());
      mappedMenu.push(this.getLogoutItem());
      return mappedMenu;
    } catch (error) {
      //determinar que hacer en error
      var errorMenu = [];
      //errorMenu.push(this.getHomeItem()); (No se necesita)
      errorMenu.push(this.getLogoutItem());
      return errorMenu;
      //throw "Error obteniendo los permisos requeridos para acceder al menú";
    }
  },
  sortedArray(level, data) {
    var localClaims = data.filter((x) => x.ClaimsParentId == level);
    if (localClaims && localClaims.length > 0) {
      var sorted = localClaims.sort((a, b) => {
        if (a.ClaimsOrder < b.ClaimsOrder) return -1;
        if (b.ClaimsOrder < a.ClaimsOrder) return 1;
        return 0;
      });
      return sorted;
    }
    return [];
  }
};

export default menuService;
